export const CRS_OPTIONS = [
  "EPSG:4326",
  "EPSG:3857",
  "EPSG:32633",
  "EPSG:32636",
  "EPSG:22700",
  "EPSG:4196",
  "EPSG:4227",
  "EPSG:4239",
  "EPSG:4210",
  "EPSG:4324",
];
